.ImportDropzone {
  margin-top: var(--space-xxl);

  p {
    text-align: left;
    color: var(--primary);
    font-weight: normal;
    font-size: 1rem;
  }

  &[data-error="true"] {
    color: var(--accent-2);

    [data-slot="error"] > li {
      font-size: 0.9375rem;
    }
  }

  &[aria-disabled="true"] {
    pointer-events: none;
  }

  &[data-loading="true"] {
    svg {
      width: 24px;
      height: 24px;
    }
  }
}
